const state = {
  currentDollarQuotation: null,
  availableDates: [],
};

const getters = {
  currentDollarQuotation(state, _getters, _rootState, rootGetters) {
    if (!state.currentDollarQuotation || !rootGetters['config/dollarSelected']) {
      return null;
    }

    return state.currentDollarQuotation[rootGetters['config/dollarSelected']];
  },
};

const actions = {
  async fetchCurrentDollarQuotation({ commit }) {
    const {
      data: {
        data: [quotation],
      },
    } = await this.$services.resource('dollar_quotations').get({ 'filter[latest]': 'created_at', 'filter[limit]': 1 });

    commit('SET_CURRENT_DOLLAR_QUOTATION', quotation);
  },

  async fetchAvailableDates({ commit }) {
    const { data: dates } = await this.$services.resource('dollar_quotations').getAvailableDates();

    commit('SET_AVAILABLE_DATES', dates);
  },
};

const mutations = {
  SET_CURRENT_DOLLAR_QUOTATION(state, value) {
    state.currentDollarQuotation = value;
  },

  SET_AVAILABLE_DATES(state, values) {
    state.availableDates = values;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
